import { Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { Component, OnDestroy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppState } from '../../model/reducer';
import { select, Store } from '@ngrx/store';
import _ from 'lodash';
import { Inventory } from '../inventory.model';
import { CreateInventory } from '../../model/inventory';
import { allInventoriesView, selectedTenantKeyView, shouldDisplayTenantsView } from '../../model/views';
import { CreateInventoryPayload } from './create-inventory-payload';
import { closeModalOnEscape } from '../../modal-dialog/modal-dialog.helper';

@Component({
    selector: 'adm4-create-inventory-container',
    template: `
    <adm4-modal-dialog-title [header]='header'
                             [showClose]='true'
                             (closeClicked)="dialogRef.close()">
      <adm4-create-inventory [inventories]='inventories$ | async'
                             [predefinedInventoryData]='predefinedInventoryData'
                             [selectedTenantKey]='selectedTenantKey$ | async'
                             [displayTenant]='displayTenant$ | async'
                             (addInventory)="onAddInventory($event)"
                             (closeClicked)='closeDialog()'></adm4-create-inventory>
    </adm4-modal-dialog-title>
  `,
    styleUrls: ['./create-inventory.component.scss'],
    standalone: false
})
export class CreateInventoryContainerComponent implements OnDestroy {
  dialogRef = inject<MatDialogRef<CreateInventoryContainerComponent>>(MatDialogRef);
  predefinedInventoryData = inject<Inventory | null>(MAT_DIALOG_DATA);
  private store$ = inject<Store<AppState>>(Store);

  header = 'Create Inventory';

  inventories$: Observable<Inventory[]>;
  displayTenant$: Observable<boolean>;
  selectedTenantKey$: Observable<string>;

  private destroyed$: Subject<boolean> = new Subject();

  constructor() {

    closeModalOnEscape(this.dialogRef, this.destroyed$);

    this.inventories$ = this.store$.pipe(select(allInventoriesView)).pipe(map(_.values));
    this.displayTenant$ = this.store$.pipe(select(shouldDisplayTenantsView));
    this.selectedTenantKey$ = this.store$.pipe(select(selectedTenantKeyView)) as Observable<string>;
  }

  onAddInventory(createInventoryPayload: CreateInventoryPayload) {
    this.store$.dispatch(new CreateInventory(createInventoryPayload));
    this.closeDialog();
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
